module.exports = __webpack_public_path__ + "img/logo.dfda034b.png";